import { WEB_CONFIG } from '../config';

/**
 * `electron` modülünün web karşılığı — yalnızca tarayıcıda anlamı olan
 * parçalar. Birkaç ortak servis sürüm numarası, harici bağlantı ve pano için
 * bunları kullanıyor. Burada olmayan bir Electron API'sini kullanan servis
 * web'de çalışmaz; ona ayrı bir karşılık yazılmalı (bkz. vite.web.config.ts).
 */

export const app = {
  getVersion: (): string => WEB_CONFIG.version,
};

export const shell = {
  async openExternal(url: string): Promise<void> {
    const parsed = new URL(url);
    if (!['https:', 'http:', 'mailto:'].includes(parsed.protocol)) return;
    if (parsed.protocol === 'mailto:') window.location.href = parsed.toString();
    else window.open(parsed.toString(), '_blank', 'noopener,noreferrer');
  },
};

export const clipboard = {
  writeText(text: string): Promise<void> {
    return navigator.clipboard?.writeText(text) ?? Promise.resolve();
  },
};
